var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    timerBackgroundColor: colors.porcelain,
    timerColor: colors.ash,
    timerBorderWidth: borders.widthSmall,
    timerBorderColor: colors.tiara,
    timerBorderRadius: borders.radiusMedium,
    timerFontSize: typography.fontSizeMedium,
    timerPadding: spacing.xxSmall,
    timerMargin: spacing.small,
    timerRightPadding: spacing.xxSmall,
    timeRemainingLabelFontSize: typography.fontSizeXSmall
  };
};
export default generateComponentTheme;